import { useEffect, useRef, useState } from 'react';
import styles from './index.module.sass';
import ArrowDown from '@/modules/mixing/images/arrow-down.svg';
import EyeVisible from '@/modules/mixing/images/eye-visible.svg';
import EyeHidden from '@/modules/mixing/images/eye-hidden.svg';

export const SelectCalculatorFields = ({ options, toggleField }: ISelectCalculatorFields) => {
  const [dropdownActive, setDropdownActive] = useState(false);
  const elemRef: any = useRef(null);

  useEffect(() => {
    const handleClickOutside = () => {
        if (event && elemRef.current && !elemRef.current.contains(event.target)) {
          setDropdownActive(false);
        }
    } 
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
  }, [])

  return (
    <div className={styles.root}>
      <div className={styles.selectComponent} ref={elemRef}>
        <div
          className={styles.selectInner}
          onClick={() => setDropdownActive(!dropdownActive)}
          style={{
            borderBottomLeftRadius: dropdownActive ? '0' : '8px',
            borderBottomRightRadius: dropdownActive ? '0' : '8px',
          }}
        >
          <span className={styles.label}>отображение полей таблицы</span>
          <img
            className={styles.statusArrow}
            src={ArrowDown}
            style={{
              transform: !dropdownActive ? 'rotate(180deg)' : 'none',
            }}
          />
        </div>
        {options && (
          <div
            className={styles.selectOptions}
            style={{ display: dropdownActive ? 'block' : 'none' }}
          >
            {options.map((item: CalculatorFieldOptionItem, i) => (
              <div className={styles.selectOption} key={i} onClick={() => toggleField(item.value)}>
                <img src={item.enabled ? EyeVisible : EyeHidden}/>
                {item.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

interface ISelectCalculatorFields {
  options: CalculatorFieldOptionItem[];
  toggleField: (val: string) => void;
}

export interface CalculatorFieldOptionItem { label: string; id: number; enabled: boolean; value: string }
